import React from 'react';

class ItemList extends React.Component {
  render() {
    const items = [
      "FireFly",
      "Stardust",
      "Crimson Sky"
    ];

    const listItems = items.map((item) =>
      <li key={item} className="list-group-item col-md-6 mx-auto">
        {item}
      </li>
    );

    return (
      <ul className="list-group">
        {listItems}
      </ul>
    );
  }
}

export default ItemList;
